import { FC } from 'react';
import { Props } from './types';
import { Container, Image, Text } from './styled';

const IconAndText: FC<Props> = ({ src, text, show }) => {
  if (!show) return null;
  return (
    <Container>
      <Image src={src} />
      <Text>{text}</Text>
    </Container>
  );
};

export default IconAndText;
